import script from "./FinishPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinishPage.vue?vue&type=script&setup=true&lang=ts"

import "./FinishPage.vue?vue&type=style&index=0&id=01865abd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01865abd"]])

export default __exports__